document.addEventListener('alpine:init', () => {
  Alpine.data('UpsellProductForm', (productId, variantId) => ({
    productId,
    variantId,
    loading: false,
    errorMessage: null,

    async addToCart() {
      this.loading = true;
      this.errorMessage = null;

      liveRegion(window.theme.strings.loading);

      const formData = new FormData();
      formData.append('id', this.variantId);
      formData.append('quantity', 1);
      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      const options = fetchConfigDefaults('application/javascript');
      options.body = formData;
      options.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete options.headers['Content-Type'];

      try {
        const response = await fetch(window.theme.routes.cart_add_url, options);
        const data = await response.json();

        if (data.status) {
          // Error occurred
          const errors = data.errors || data.description;
          const message = data.description || data.message;
          this.errorMessage = message || window.theme.strings.cartError;
          this.loading = false;

          document.dispatchEvent(
            new CustomEvent('theme:product:error:add-to-cart', {
              detail: {
                productId: this.productId,
                variantId: this.variantId,
                errors,
                message,
              },
            })
          );
        } else {
          // Success
          this.loading = false;

          // Dispatch event to update cart (cart-items.js and cart-footer.js will handle the updates)
          const formId = this.$root.querySelector('form')?.getAttribute('id') || `upsell-form-${this.productId}`;
          document.body.dispatchEvent(
            new CustomEvent('baseline:cart:afteradditem', {
              bubbles: true,
              detail: {
                response: data,
                sourceId: formId,
              },
            })
          );
        }
      } catch (error) {
        console.error('Error adding product to cart:', error);
        this.errorMessage = window.theme.strings.cartError || 'An error occurred';
        this.loading = false;
      }
    },
  }));
});
